import { apiCall } from "./service";
import {
  URL_PROGRAM,
  URL_PROJECTS,
  URL_RISK,
  URL_GET_RISK_DETAILS,
  URL_CREATE_RISK,
  URL_UPDATE_RISK,
  URL_DELETE_RISK,
  URL_RISK_FLAG,
  URL_GET_SEARCH_CHANGE_REQUEST,
  URL_PORTFOLIO,
  BASE_URL,
} from "./URL";

export const api = {
  riskRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;

    switch (parent) {

      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/Risks`;
        break;

      case "Program":
        url = `${BASE_URL}Programs/${id}/Risks`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/Risks`;
        break;

      case "Severity":
        url = `${BASE_URL}Risks`;
        paginationParams.impact = `eq:${params.Severity.impact}`;
        paginationParams.probability = `eq:${params.Severity.probability}`;
        break;

      case "ProjectSeverity":
        url = `${BASE_URL}Projects/${id}/Risks`;
        paginationParams.impact = `eq:${params.Severity.impact}`;
        paginationParams.probability = `eq:${params.Severity.probability}`;
        break;
      default:
        url = `${BASE_URL}Risks`;
    }

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },
  getRiskDetailsRequest(params) {
    return apiCall.get({
      url: `${URL_GET_RISK_DETAILS}${params.id}`,
      isAuthToken: true,
      params: params,
    });
  },
  createRiskRequest(params) {
    return apiCall.post({
      url: `${URL_CREATE_RISK}`,
      isAuthToken: true,
      params: params.payload,
    });
  },
  updateRiskRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_RISK}${params.rId}`,
      params: params.payload,
    });
  },
  deleteRiskRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_RISK}${params.id}` });
  },
  sortRiskRequest(params) {
    if (params.parent === "Project")
      return apiCall.pagination({
        url: `${URL_PROJECTS}/${params.id}/Risks?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Program")
      return apiCall.pagination({
        url: `${URL_PROGRAM}${params.id}/Risks?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Risk")
      return apiCall.pagination({
        url: `${URL_RISK}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
    if (params.parent === "Portfolio")
      return apiCall.pagination({
        url: `${URL_PORTFOLIO}/${params.id}/Risks?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
        isAuthToken: true,
      });
  },
  updateRiskFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_RISK_FLAG}${params.id}`,
      params: params.payload,
    });
  },

  searchChangeRequest(params) {
    return apiCall.get({
      url: `${URL_GET_SEARCH_CHANGE_REQUEST}${params}`,
      isAuthToken: true,
      params,
    });
  },
  patchField(id, field, value) {
      return apiCall.patch({
        url: `${URL_RISK}${id}`,
        isAuthToken: true,
        params: [{ op: "replace", path: `/${field}`, value }],
      });
    },
};

export default api;
